export default __webpack_public_path__ + "static/media/about-img.80de901c.jpg";